// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__1ii7T","item":"PaymentsMobile_item__1rFCq","label":"PaymentsMobile_label__2WWQl","amount":"PaymentsMobile_amount__29QKO"};